module.exports = __webpack_public_path__ + "static/media/spork.62518b8b.png";